// export const BASE_URL = "http://localhost:8000";
export const BASE_URL = "https://algoo-server-1rdl.onrender.com";
